import yup, { string, object } from 'yup'
import { SchemaRules } from './schemaValidator'

const validationMessage = 'This field is required.'

export const facilityContactSchema = {
  name: string().nullable(),
  email: string().email('Must be a valid email').required(validationMessage),
  phone: string(),
  phoneExt: string().nullable(),
}

const facilityContactSchemaObject = object(facilityContactSchema)

export type FacilityContactSchema = Partial<yup.InferType<typeof facilityContactSchemaObject>>

const facilityContactValidator = new SchemaRules<FacilityContactSchema>(facilityContactSchema)
export default facilityContactValidator
